module.exports = __webpack_public_path__ + "media/images/fbcalls/bitget-a5ee7d9544ffc972789566da6dabfe00.png";